import axios from "../util/axios";
import config from "../config/config";

interface CreatePlaylistItemParams {
  title: string;
  artist: string;
  radio_playlist: string;
  order?: number;
  file: File;
}

interface GenerateUploadUrlParams {
  title: string;
  artist: string;
  radio_playlist: string;
  order?: number;
  filename: string;
  content_type: string;
}

export async function createPlaylist(params: any) {
  return axios.post(`${config.defaults.api_url}/radio/playlist`, params);
}

export async function updatePlaylist(id: string, params: any) {
  return axios.put(`${config.defaults.api_url}/radio/playlist/${id}`, params);
}

export async function deletePlaylist(id: string) {
  return axios.delete(`${config.defaults.api_url}/radio/playlist/${id}`);
}

export async function getPlaylists(params: any) {
  return axios.get(`${config.defaults.api_url}/radio/playlist`, { params });
}

export async function getPlaylist(id: string) {
  return axios.get(`${config.defaults.api_url}/radio/playlist/${id}`);
}

export async function createPlaylistItem(params: CreatePlaylistItemParams) {
  const formData = new FormData();
  formData.append("title", params.title);
  formData.append("artist", params.artist);
  formData.append("radio_playlist", params.radio_playlist);
  if (params.order !== undefined) {
    formData.append("order", params.order.toString());
  }
  formData.append("file", params.file);
  return axios.post(
    `${config.defaults.api_url}/radio/playlist-item`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
}

export async function updatePlaylistItem(id: string, params: any) {
  return axios.put(
    `${config.defaults.api_url}/radio/playlist-item/${id}`,
    params,
  );
}

export async function deletePlaylistItem(id: string) {
  return axios.delete(`${config.defaults.api_url}/radio/playlist-item/${id}`);
}

export async function getPlaylistItem(id: string) {
  return axios.get(`${config.defaults.api_url}/radio/playlist-item/${id}`);
}

export async function uploadPlaylistItemFile(id: string, file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(
    `${config.defaults.api_url}/radio/playlist-item/${id}/file`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
}

export async function generateUploadUrl(params: GenerateUploadUrlParams) {
  return axios.post(
    `${config.defaults.api_url}/radio/generate-upload-url`,
    params,
  );
}

export async function completeUpload(itemId: string) {
  return axios.post(
    `${config.defaults.api_url}/radio/complete-upload/${itemId}`,
  );
}
